import { render, staticRenderFns } from "./DepartmentPageForm.vue?vue&type=template&id=b1024bb2&scoped=true&"
import script from "./DepartmentPageForm.vue?vue&type=script&lang=js&"
export * from "./DepartmentPageForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1024bb2",
  null
  
)

export default component.exports